import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m6.5 6.5 11 11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m21 21-1-1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m3 3 1 1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m18 22 4-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m2 6 4-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m3 10 7-7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m14 21 7-7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Dumbbell";
const Dumbbell = memo(themed(Icon));
export {
  Dumbbell
};
//# sourceMappingURL=dumbbell.js.map
